const WrapperMode = {
  Dynamic: "dynamic",
  Fixed: "fixed",
};

export default WrapperMode;
